import PropTypes from 'prop-types';

import { 
  ZF_JSON_OBJECT_TYPE_PROPERTY, 
  ZF_JSON_OBJECT_VERSION_PROPERTY,
  ZF_JSON_IMAGE_TYPE,
  ZF_JSON_IMAGE_CROP_DATA_TYPE
} from 'const_shared.js';

export const zfImageCropDataPropType = PropTypes.exact({
  [ZF_JSON_OBJECT_TYPE_PROPERTY]: PropTypes.oneOf([ZF_JSON_IMAGE_CROP_DATA_TYPE]).isRequired,
  [ZF_JSON_OBJECT_VERSION_PROPERTY]: PropTypes.number.isRequired,
  originalImageSrc: PropTypes.string.isRequired,
  borderRadius: PropTypes.number.isRequired,
  isOutOfBoundsAllowed: PropTypes.bool,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  aspectRatio: PropTypes.number,
  originalImageWidth: PropTypes.number,
  originalImageHeight: PropTypes.number
});

export const zfImagePropType = PropTypes.exact({
  [ZF_JSON_OBJECT_TYPE_PROPERTY]: PropTypes.oneOf([ZF_JSON_IMAGE_TYPE]).isRequired,
  [ZF_JSON_OBJECT_VERSION_PROPERTY]: PropTypes.number.isRequired,
  src: PropTypes.string.isRequired,
  isUncroppable: PropTypes.bool,
  isUnsignable: PropTypes.bool,
  isUncompressed: PropTypes.bool.isRequired,
  isUncompressable: PropTypes.bool.isRequired,
  cropData: zfImageCropDataPropType
});

